import { useCallback } from 'react';

export const useStorage = () => {
  const getItem = useCallback((key: string) => {
    try {
      const val = localStorage.getItem(key);
      return val;
    } catch (error) {
      console.warn('getItem', key, 'error', error);
      return undefined;
    }
  }, []);

  const setItem = useCallback((key: string, value: string) => {
    try {
      if (value === undefined) {
        console.warn('setItem', key, 'undefined');
        return false;
      }
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      console.warn('setItem', key, 'error', error);
      return false;
    }
  }, []);

  const removeItem = useCallback((key: string) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn('removeItem', key, 'error', error);
    }
  }, []);

  return {
    localStorage,
    getItem,
    setItem,
    removeItem,
  };
};

export default useStorage;
